export const SHOP_DOCUMENT_STATUSES = {
  pending: {
    label: 'Pending',
    description: 'Document is pending review or approval.',
    color: 'text-yellow-600 bg-yellow-50 border-yellow-200',
    icon: 'exclamation-triangle',
    key: 'pending',
  },
  approved: {
    label: 'Approved',
    description: 'Document has been approved.',
    color: 'text-green-600 bg-green-50 border-green-200',
    icon: 'check-circle',
    key: 'approved',
  },
  rejected: {
    label: 'Rejected',
    description: 'Document has been rejected.',
    color: 'text-red-600 bg-red-50 border-red-200',
    icon: 'x-circle',
    key: 'rejected',
  },
}
